<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">{{ $t("message.menu.twh") }}</h4>
            </div>
            <div class="card-body px-3">
              <router-link
                :to="{ name: 'twh-new' }"
                class="ml-md-auto float-right mb-4 btn btn-success btn-round btn-rounded btn-pill"
                id="add-new-twh"
                title-link-class="btn-success text-white"
                >{{ $t("message.twh.new") }}</router-link
              >
              <b-table
                id="twh-table"
                responsive
                :items="twhs"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                @row-clicked="open_twh"
              >
                <template v-slot:cell()="data">
                  <router-link
                    class="text-dark"
                    :to="{
                      name: 'twh-single',
                      params: { id: data.item.docid },
                    }"
                    >{{ data.value }}</router-link
                  >
                </template>
                <template v-slot:cell(placedate)="data">
                  {{ momentum(data.value) }}
                </template>
                <template v-slot:cell(noticedate)="data">
                  {{ momentum(data.value) }}
                </template>
                <template v-slot:cell(dateout)="data">
                  {{ momentum(data.value) }}
                </template>

                <template v-slot:cell(remove)="data">
                  <button
                    class="btn btn-sm btn-link text-danger"
                    @click="removeTWH(data)"
                    v-if="can_remove(data)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="twhs.length"
                  :per-page="perPage"
                  aria-controls="orders-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 0,
      cleave: {
        numeral: true,
      },
      fields: [
        {
          key: "docid",
          label: this.$t("message.twh.docid"),
        },
        {
          key: "transportnum",
          label: this.$t("message.twh.transportnum"),
        },
        {
          key: "carriername",
          label: this.$t("message.twh.carriername"),
        },
        {
          key: "trailernum",
          label: this.$t("message.twh.trailernum"),
        },
        {
          key: "placedate",
          label: this.$t("message.twh.placedate"),
        },
        {
          key: "noticedate",
          label: this.$t("message.twh.noticedate"),
        },
        {
          key: "specialist",
          label: this.$t("message.twh.specialist"),
        },
        {
          key: "dateout",
          label: this.$t("message.twh.dateout"),
        },
        {
          key: "notifcuststatus",
          label: this.$t("message.twh.notifcuststatus"),
        },
        {
          key: "pr_vygr",
          label: this.$t("message.twh.pr_vygr"),
        },
        {
          key: "notifnum",
          label: this.$t("message.twh.notifnum"),
        },
        {
          key: "custmark",
          label: this.$t("message.twh.custmark"),
        },
        {
          key: "remove",
          label: "",
          sortable: false,
          tdClass: "text-right",
        },
      ],
      twhs: [],
    };
  },
  methods: {
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    open_twh(item) {
      this.$router.push({ name: "twh-single", params: { id: item.docid } });
    },
    gotoNew() {
      this.$router.push({ name: "twh-new" });
    },
    load() {
      axios
        .get(window.base + "/document/getDocNotifications")
        .then((response) => {
          this.twhs = response.data;
        });
    },
    can_remove(data) {
      return true;
    },
    removeTWH(data) {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.twh.confirm_removal"), {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            axios
              .post(
                window.base +
                  "/document/deleteDocNotification?id=" +
                  data.item.id,
              )
              .then((r) => {
                this.load();
              });
          }
        })
        .catch((err) => {
          this.load();
        });
    },
    isTwh() {
      if (window.dev_mode) return true;
      // return true
      let has_role = false;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "twh") has_role = true;
      });
      if (!has_role && this.$store.state.user.role_id == 8) has_role = true;
      return has_role;
    },
  },
  mounted() {
    if (!this.$store.state.auth) {
      this.$router.push({ name: "sign-in" });
    } else {
      if (!this.isTwh()) {
        this.$router.push({ name: "home-after-login" });
      } else this.load();
    }
  },
  computed: {
    user_id() {
      return this.$store.state.user.id;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {
    $route() {
      this.load();
    },
  },
};
</script>
